import React, { useState, useEffect, useCallback } from "react";
import { Container, Box, Tooltip } from "@material-ui/core";
import {
  Typography,
  AppBar,
  Toolbar,
  Link,
  CardActionArea,
  TextField,
  Button,
  Paper,
  FormControlLabel,
  Checkbox,
  Chip,
  Avatar,
  IconButton,
} from "@material-ui/core";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Switch,
  Divider,
  CircularProgress
} from "@material-ui/core";
import {
  DesktopMac,
  Add,
  FilterList,
  CheckCircle,
  Group,
  Block,
  AccountCircle,
  Close,
  Edit,
  Delete,
  Assignment,
  VpnLock,
  Money,
  AccountBalance,
  Schedule,
  VpnKey
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";

import MUIDataTable from "mui-datatables";

import { makeStyles } from "@material-ui/styles";
import { Skeleton } from "@material-ui/lab";

import { useSnackbar } from "notistack";

import {
  FinanceService,
  AdminService,
  Validator,
  hasPermission
} from "../../../../../utils/web_config";
import { useAccountTypes, useInternalAccounts } from "../../../hooks/use_hooks";
const axios = require("axios");

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
    marginRight: 5
  },
  btn2: {
    textTransform: "capitalize",
    border: "dashed grey 1px",
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
}));

function CustomersAccounts(props) {
  const classes = useStyles();
  const history = useHistory();

  const accountTypes = useAccountTypes();
  const internalAccounts = useInternalAccounts();

  const [accountData, setAccountData] = useState({});
  const [accounts, setAccounts] = useState({
    page: 0,
    count: 0,
    rowsPerPage: 10,
    filters:"",
    status: "Loading accounts....",
    loading: false,
    toggling: false,
    data: [],

  });

  const [customersStats, setCustomersStats] = useState({
    loading: false,
    data: [],
    error:false
  });

  var statsUrls = [
    {"name":"All","url":new FinanceService().GET_ALL_ACCOUNTS+'?account_type_name=CUSTOMER'},
    {"name":"Minors","url": new FinanceService().GET_ALL_ACCOUNTS+'?account_type_name=CUSTOMER&maturity_type=MINOR'},
    {"name":"Adults","url": new FinanceService().GET_ALL_ACCOUNTS+'?account_type_name=CUSTOMER&maturity_type=ADULT'},
    {"name":"Cards","url": new FinanceService().GET_ALL_ACCOUNTS+'?account_type_name=CUSTOMER&wallet_type=CARD'},
    {"name":"Green cards","url": new FinanceService().GET_ALL_ACCOUNTS+'?account_type_name=CUSTOMER&wallet_type=GREEN_CARD'},
    {"name":"Internal","url": new FinanceService().GET_ALL_ACCOUNTS+'?account_type_name=CUSTOMER&wallet_type=INTERNAL'},
    //{"name":"Enabled","url": new FinanceService().GET_ALL_ACCOUNTS+'?account_type_name=CUSTOMER&status=ENABLED'},
    //{"name":"Enabled","url": new FinanceService().GET_ALL_ACCOUNTS+'?account_type_name=CUSTOMER&status=DISABLED'},
  ]
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [typesOpen, setTypesOpen] = useState(false);
  const [pinOpen,setPinOpen]= useState(false);

  const [internalOpen, setInternalOpen] = useState(false);

  useEffect(() => {
    var accountData = new AdminService().accountData;
    setAccountData(accountData);
    getAccounts(accountData.token);
  }, []);

  ///////////////

  const columns = [
    {
      name: "id",
      label: "id",
      options: {
        filter: false,
        sort: false,
        display: "excluded",
      },
    },
    {
      name: "organization_id",
      label: "Org id",
      options: {
        filter: false,
        sort: false,
        display: "excluded",
      },
    },
    {
      name: "user_id",
      label: "User id",
      options: {
        filter: false,
        sort: false,
        display: "excluded",
      },
    },
    {
      name: "account_number",
      label: "Acc number",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "account_name",
      label: "Customer name",
      options: {
        filter: true,
        sort: true,
        filterType: "textField",
      },
    },
    {
      name: "maturity_type",
      label: "Maturity",
      options: {
        filter: true,
        sort: true,
        filterType: "dropdown",
      },
    },

    {
      name: "phone_number",
      label: "Phone number",
      options: {
        filter: true,
        sort: true,
        filterType: "textField",
      },
    },
    {
      name: "serial_number",
      label: "Serial number",
      options: {
        filter: true,
        sort: true,
        filterType: "textField",
      },
    },
    {
      name: "wallet_type",
      label: "Wallet type",
      options: {
        filter: true,
        sort: true,
        filterType: "dropdown",
      },
    },
    {
      name: "current_balance",
      label: "Account balance",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (
          <span>{new Validator().formatMoney(value)}</span>
        ),
      },
    },
    {
      name: "status2",
      label: "Status2",
      options: {
        filter: false,
        sort: false,
        display: "excluded",
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: false,
        filterType: "dropdown",
        customBodyRenderLite: function (dataI, rowI) {
          return (
            <Chip
              avatar={
                <Avatar>
                  {accounts.data[dataI].status.toLowerCase() == "enabled" ? (
                    <CheckCircle fontSize="small" />
                  ) : (
                    <Block fontSize="small" />
                  )}
                </Avatar>
              }
              variant="outlined"
              color={
                accounts.data[dataI].status.toLowerCase() == "enabled"
                  ? "primary"
                  : "default"
              }
              size="small"
              label={capitalize(accounts.data[dataI]?.status)}
            />
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'textField',
    elevation: 0,
    selectableRows: "none",
    search:false,
    selectableRowsOnClick: true,
    fixedHeader: true,
    confirmFilters: true,
    count:accounts.count,
    page: accounts.page,
    rowsPerPage:accounts.rowsPerPage,
    serverSide: true,
    customFilterDialogFooter: (selectedRows, applyFilters) => (
      <DialogActions>
        <Button
          color="primary"
          onClick={() => {
            applyFilters();
            setTypesOpen(false);
          }
          }
        >
          Apply filters
        </Button>
        </DialogActions>
    ),   
    onCellClick: (cellData, cellMeta) => {
      var acc = accounts.data[cellMeta.dataIndex];

      if(hasPermission("CAN_VIEW_CUSTOMERS_ACCOUNT")){
      history.push("/centrika/accounts/details", acc);
      }

    },
    searchProps: {
      variant: "outlined",
      margin: "dense",
    },
    textLabels: {
      body: {
        noMatch: accounts.status,
      },
    },
    pagination: !accounts.loading,
    onChangePage: (page) => {
      setAccounts({
        ...accounts,
        page: page,
      });
      getAccounts(accountData.token,accountData.filters,page);
    },
    onChangeRowsPerPage: (rowsPerPage) => {
      setAccounts({
        ...accounts,
        rowsPerPage: rowsPerPage,
      });
      getAccounts(accountData.token,accountData.filters,accounts.page,rowsPerPage);
    },
    // onSearchChange: (searchText) => {
    //   setAccounts({
    //     ...accounts,
    //     filters: `account_name=${searchText}`,
    //   });

    //   getAccounts(accountData.token,`account_name=${searchText}`,accounts.page,accounts.rowsPerPage);
    // },
    onTableChange: (action, tableState) => {

      switch (action) {
        case "changePage":
        
          break;

          case "filterChange":
            //get filter list
            var filterList = tableState.filterList;

            var filters=filterList.map((filter,i) => {
              return {
                columnName: tableState.columns[i].name,
                value: filter.length?filter[0].toLowerCase():undefined,
              };
            }
            );

            filters = filters.filter((filter) => {
              return filter.value;
            }
            );

            //convert filter list into url query params
            var queryParams = filters.map((filter) => {
              return `${filter.columnName}=${filter.value}`;
            }
            ).join("&");

            if(filters.length){
              setAccounts({
                ...accounts,
                filters: queryParams,
              })
              getAccounts(accountData.token, queryParams,);
            }else{
              setAccounts({
                ...accounts,
                filters: "",
              })
              getAccounts(accountData.token, "",);
            }
          
          break;
          
        default:
          break;
      }
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      // <CustomAccountsToolbar
      //   selectedRows={selectedRows}
      //   displayData={displayData}
      //   setSelectedRows={setSelectedRows}
      //   toggleUser={toggleUser}
      //   openEdit={showUserEdit}
      //   toggling={accounts.toggling}
      // />
      <></>
    ),
  };
  /////////////////////
  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };

  const capitalize = (s) => {
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  };

  ///////////////////////
//create a promise to get active customers
  const getCustomersStats = async (token,url,filters="") => {

    return new Promise(async(resolve, reject) => {
    try {
      const response = await axios.get(
        url.url+"&"+filters,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      var total=response.headers['x-total-count']
      var name=url.name;
      var data={name:name,total:total};
      resolve(data);
     
    }
    catch (error) {
      reject()
    }
  });

  };



  ////////////////
  ///////////////////////////////////

  const getAccounts = (token,filters="",page=0,perPage=undefined) => {
    const accsInstance = axios.create(new AdminService().getHeaders(token));

    setAccounts({ ...accounts, loading: true });

    accsInstance
      .get(
        new FinanceService().GET_ALL_ACCOUNTS +
          `?per_page=${perPage??accounts.rowsPerPage}&page=${parseInt(page)===0?page+1:page}&account_type_name=CUSTOMER&${filters}`
      )
      .then(function (response) {
        setAccounts({ ...accounts, loading: false });

        const d = response.data;

        if (d.data.length == 0) {
          setAccounts({
            ...accounts,
            data:[],
            status: "There are no customers available.",
          });
        } else {
          var acs = [];

          d.data.forEach((a, i) => {
            const newAcc = a;
            newAcc["status2"] = a.status;

            acs.push(newAcc);
          });

          var total=response.headers['x-total-count']
          var pages=new Validator().parsePagination(response.headers.link)

          setAccounts({
            ...accounts,
            data: acs,
            count:total
            //page:pages?.next,
          });
          //log the headers
         
          

        }
      })
      .catch(function (error) {
        setAccounts({ ...accounts, loading: false });
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }
        setAccounts({
          ...accounts,
          status: e,
        });

        notify(
          error?.response?.status == 404 ? "info" : "error",
          e,
          error?.response?.status
        );
      });

      Promise.all(statsUrls.map(async (url) => getCustomersStats(token,url,filters))).then(function(values){
        setCustomersStats({
          ...customersStats,
          data:values
        })

      }).catch(function(error){
        setCustomersStats({
          ...customersStats,
          error:true,
          loading:false
      })
        notify(
          "warning",
          "Error getting customers stats,try again",
          500
        );
      })

  };


  const [pan,setPan] = useState({ value: '', error: ''});
  const [pinLoading,setPinLoading]= useState(false);

  const requestPin =()=>{
    const pinInstance = axios.create(new AdminService().getHeaders(accountData.token));
    setPinLoading(true);
    const data = {
      pan: pan.value
    }
    pinInstance
      .post(new FinanceService().REQUEST_PIN, data)
      .then(function (response) {
        setPinLoading(false);
        setPinOpen(false)
        notify("success", response.data.message);
      })
      .catch(function (error) {
        setPinLoading(false);
        var e = error.message;
        if (error.response) {
          e = error.response.data.message;
        }
        notify(error?.response?.status == 404 ? "info" : "error", e, error?.response?.status);
      });
  }


  return (
    <div className={classes.root}>
      {/* Dialogs ends here */}

      {/* //////////////////////////////////////// */}
      <Dialog
        open={typesOpen}
        onClose={() => setTypesOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">{"Account types"}</DialogTitle>
        <DialogContent>
          {accountTypes.status == "error" || accountTypes.status == "empty" ? (
            <Box p={5} display="flex" justifyContent="center">
              {accountTypes.status == "error" ? (
                <Typography>
                  Error loading account types, try to refresh
                </Typography>
              ) : (
                <Typography>
                  There are no account types available yet.
                </Typography>
              )}
            </Box>
          ) : (
            <List>
              {accountTypes.status != "loading"
                ? accountTypes.data.map((tp, i) => (
                    <>
                      {i != 0 && i != accountTypes.data.length && (
                        <Divider variant="middle" />
                      )}
                      <ListItem key={i} dense>
                        <ListItemText
                          primary={tp.name}
                          secondary={tp.description}
                        />
                        <ListItemSecondaryAction>
                          <Switch
                            color="primary"
                            checked={tp.status == "ENABLED"}
                          />
                        </ListItemSecondaryAction>
                      </ListItem>
                    </>
                  ))
                : [1, 2, 3, 4, 5].map((item, i) => (
                    <ListItem key={i}>
                      <ListItemText
                        primary={
                          <Skeleton
                            variant="text"
                            width={"100%"}
                            style={{ borderRadius: 7 }}
                          />
                        }
                      />
                    </ListItem>
                  ))}
            </List>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setTypesOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* //////////////////////////////////////// */}
      <Dialog
        open={pinOpen}
        onClose={() => setPinOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">{"Reset PIN"}</DialogTitle>
        <DialogContent>
          <Box>
            <Box mt={2}>
              <Translate>
                {({ translate }) => (
                  <TextField
                    size="small"
                    variant="outlined"
                    color="primary"
                    type="text"
                    value={pan.value}
                    placeholder={"PAN Number"}
                    label={"PAN Number"}
                    fullWidth
                    onChange={(v)=>{
                      setPan({value: v.target.value, error: ''});
                    }}
                    helperText={pan.error}
                    error={pan.error !== ""}
                  />
                )}
              </Translate>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setPinOpen(false)} color="primary">
            Close
          </Button>
          <Button
            disabled={pinLoading}
            variant="contained"
            color="primary"
            onClick={requestPin}
            disableElevation
          >
            {pinLoading ? (
              <CircularProgress size={23} />
            ) : (
              "Request PIN"
            )}
          </Button>
        </DialogActions>
      </Dialog>
      {/* ////////////////////////////// */}
      <Box display="flex">
        <Box mr={2}>
          {" "}
          <Group color="primary" fontSize="large" />
        </Box>
        <Typography variant="h5" className={classes.title}>
          <b>Customers accounts</b>
        </Typography>


        <Button
          className={classes.btn}
          color="primary"
          variant="contained"
          size="medium"
          startIcon={<VpnKey />}
          disableElevation
          onClick={() => setPinOpen(true)}
        >
          Request PIN
        </Button>

        <Button
          className={classes.btn}
          color="primary"
          variant="contained"
          size="medium"
          startIcon={<Assignment />}
          disableElevation
          onClick={() => setTypesOpen(true)}
        >
          Account types
        </Button>
      </Box>
      <Box mt={3} />
  
       {customersStats.error? <Box height={50} width={1} diaplay='flex' alignItems='center' justifyContent='center'><Typography color="textSecondary" align="center">
                  Error loading customers stats, try to refresh
                </Typography></Box> :
      <Grid container spacing={2}>
        {customersStats.data.map((tr, i) => (
          <Grid item xs={12} md={4} lg={3}>
            <Paper elevation={0} className={classes.paper}>
              <Box width={1}>
                <Box display="flex" width={1}>
                  <Box flexGrow={1}>
                    <Typography className={classes.btn} color="textSecondary">
                      {tr.name}
                    </Typography>
                
                  </Box>
                  {new Validator().getTransactionIcon("PERSON")}
                </Box>
                <Box
                  mt={1}
                  mb="4px"
                  display="flex"
                  alignItems="flex-end"
                  justifyContent="space-between"
                  width={1}
                >
                  <Tooltip
                    title={tr.total}
                    arrow
                    placement="top"
                  >
                    <Typography variant="h5">
                      {
                       new Validator().formatNumber(tr.total)
                      }
                    </Typography>
                  </Tooltip>

                  {/* <Typography color="primary" align="right">
                    {new Validator().formatMoney(
                      new Validator().sum(transactions?.groups[tr], "amount")
                    )}
                  </Typography> */}
                </Box>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>}
      <Box mt={2} />
      {accounts.loading && <LinearProgress />}
      <MUIDataTable
        title={"List of all customers accounts"}
        data={accounts.data}
        columns={columns}
        options={options}
      />
    </div>
  );
}

export default withLocalize(CustomersAccounts);
